import { STORAGE_KEYS, stripAnswersFromHistory } from './utils';

/**
 * Debug Utilities for Crackle
 * Exposes a loader function to the browser console to load sample history datasets.
 */

window.loadSampleData = async () => {
    console.log("%c--- Crackle Sample Data Loader ---", "color: #538d4e; font-weight: bold; font-size: 1.2rem;");

    // 1. Probe for available files
    const availableSamples = [];
    console.log("Probing for sample files...");

    for (let i = 1; i <= 5; i++) {
        try {
            const resp = await fetch(`/sample_history_${i}.txt`);
            const contentType = resp.headers.get("content-type");
            // Check if file exists AND isn't an HTML fallback from the dev server
            if (resp.ok && contentType && !contentType.includes("text/html")) {
                availableSamples.push(i);
            }
        } catch (e) {
            // Ignore fetch errors during probing
        }
    }

    if (availableSamples.length === 0) {
        console.error("No sample history files found in the /public folder.");
        return;
    }

    // 2. List available files
    console.log(`%cFound ${availableSamples.length} valid sample dataset(s):`, "font-weight: bold;");
    availableSamples.forEach(id => {
        console.log(`[${id}] sample_history_${id}.txt`);
    });

    // 3. Ask user for input
    const choice = prompt(`Found ${availableSamples.length} files. Enter the number to load (${availableSamples.join(', ')}):`);

    if (!choice || !availableSamples.includes(parseInt(choice))) {
        console.log("Cancelled or invalid selection.");
        return;
    }

    // 4. Load the file
    try {
        const resp = await fetch(`/sample_history_${choice}.txt`);
        const data = await resp.json();

        // 5. Save to localStorage (strip answers to avoid persisting secrets)
        const sanitized = stripAnswersFromHistory(data);
        localStorage.setItem(STORAGE_KEYS.game.history, JSON.stringify(sanitized));

        console.log(`%cSuccessfully loaded sample_history_${choice}.txt!`, "color: #538d4e; font-weight: bold;");
        console.log("Updating stats and reloading page...");

        // Give the UI a moment to show the message before reloading
        setTimeout(() => {
            window.location.reload();
        }, 1000);

    } catch (err) {
        console.error("Failed to load sample data:", err);
    }
};
